<!--
  Grid:

  ² = Hidden for screenreader
  ³ = mobile view and screenreader only

  Visibility:
  - type: l-xl
  - status: s-xl
  - creationDate: xl
  - dueDate: m-xl


  label(h3)      | type²       | status²      | creationDate²   | dueDate²
  ===========================================================================================
  Name(h4)       | Value²      | Value²       | Value²          | Value²          [Details]

  type³          Value³
  status³        Value³
  creationDate³  Value³
  dueDate³       Value³

-->

<template>
  <section v-if="items.length > 0" class="grid">
    <div class="row header">
      <div class="col-xl-3 col-l-4 col-m-7 col-s-6 col-xs-12">
        <h3>
          <slot name="label" />
        </h3>
      </div>
      <div class="col-l-2 col-m-hide col-s-hide col-xs-hide">
        <VSortButton v-bind="sort" :index="2" @sort="onSort">
          {{ $t('order.type_label') }}
          <!-- #S573 -->
        </VSortButton>
      </div>
      <div class="col-xl-2 col-l-hide col-m-hide col-s-hide col-xs-hide">
        <VSortButton v-bind="sort" :index="3" class="small-h3" @sort="onSort">
          {{ $t('order.externalid_label_short') }}
          <!-- #S574 -->
        </VSortButton>
      </div>
      <div class="col-xl-2 col-l-3 col-m-hide col-s-hide col-xs-hide">
        <VSortButton v-bind="sort" :index="4" @sort="onSort">
          {{ $t('order.dueDate_label_short') }}
          <!-- #S575 -->
        </VSortButton>
      </div>
      <div class="col-l-3 col-m-4 col-s-6 col-xs-hide">
        <VSortButton v-bind="sort" :index="5" @sort="onSort">
          {{ $t('order.status_label') }}
          <!-- #S576 -->
        </VSortButton>
      </div>
    </div>

    <slot v-for="item in sortedItems" name="item" :item="item" />
  </section>
  <section v-else-if="!hideEmpty" class="grid">
    <h3>
      <slot name="label" />
    </h3>
    <slot name="empty" />
  </section>
</template>

<script>
import VSortButton from './SortButton';

export default {
  name: 'OrderOverviewGrid',

  components: {
    VSortButton,
  },

  props: {
    items: {
      type: Array,
      required: true,
    },

    hideEmpty: {
      type: Boolean,
      required: false,
    },
  },

  data() {
    return {
      sort: {
        activeIndex: 1,
        inverted: false,
      },
    };
  },

  computed: {
    sortedItems() {
      return this.items
        .map(item => {
          item.label1 = item.subscriptionTemplateName
            ? item.subscriptionTemplateName
            : this.$tf('order.default_subscriptionTemplateName_' + item.orderType, item.subscriptionTemplateId);
          item.label2 = this.$t('order.type_' + item.orderType);
          item.label3 = item.externalOrderID;
          item.label4 = item.dueDate;
          item.label5 = this.$t('order.orderState_' + item.orderStatus);
          return item;
        })
        .sort((a, b) => a['label' + this.sort.activeIndex].localeCompare(b['label' + this.sort.activeIndex]) * (this.sort.inverted ? -1 : 1));
    },
  },

  methods: {
    onSort(index) {
      this.sort.inverted = this.sort.activeIndex === index && !this.sort.inverted;
      this.sort.activeIndex = index;
    },
  },
};
</script>
